import { background } from './velans2.mjs'
import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/260708/velans2/velans2-le_ineos26--{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body],
  resolveOptions: () => ({}),
}
